export default __webpack_public_path__ + "static/media/beacon_teq_life.b6c58e2b.png";